const PRICE_SELECTOR = '.boost-sd__product-price-wrapper[aria-label]:not([role])';
const LIST_SELECTOR = '.boost-sd__product-list, .boost-sd__product-list-wrapper';

const fix = (root = document) => {
    root.querySelectorAll(PRICE_SELECTOR).forEach((el) => {
        el.setAttribute('role', 'group');
    });
};

const attachObserver = () => {
    const list = document.querySelector(LIST_SELECTOR);
    if (!list) return false;
    fix(list);
    const observer = new MutationObserver(() => fix(list));
    observer.observe(list, { childList: true, subtree: true });
    return true;
};

export default function fixBoostPriceAriaRole() {
    fix();
    if (attachObserver()) return;

    const bootstrap = new MutationObserver(() => {
        if (attachObserver()) bootstrap.disconnect();
    });
    bootstrap.observe(document.body, { childList: true, subtree: true });
}
